import type { TMessages } from '@/types/TMessages'

export const messages = {
  sectionHeader: 'Кредиты и лизинг',
  sectionSubheader: 'Специальные условия для аграриев: получите деньги на развитие вашего бизнеса',
} satisfies TMessages
